(function(){
  var btn = document.getElementById('gseice-backtop');
  if(!btn) return;

  // —— 可配参数（从 data-* 读取）——
  var SHOW_AFTER_VH   = parseFloat(btn.dataset.showAfter   || '1.6');  // 超过多少屏才允许出现
  var STOP_DELAY      = parseInt  (btn.dataset.stopDelay   || '160',10); // “滚动停止”判定时间
  var BOTTOM_DESKTOP  = parseInt  (btn.dataset.bottomDesktop || '96',10);
  var BOTTOM_MOBILE   = parseInt  (btn.dataset.bottomMobile  || '96',10);

  // —— 固定静态位置（零抖动）——
  function placeStatic(){
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    btn.style.bottom = (isMobile ? BOTTOM_MOBILE : BOTTOM_DESKTOP) + 'px';
    // right 在 CSS 里固定 16px，与客服按钮一致
  }

  placeStatic(); // 初始化一次

  // —— 计算是否越过阈值 —— 
  function beyondThreshold(){
    var y = window.scrollY || document.documentElement.scrollTop;
    return y > window.innerHeight * SHOW_AFTER_VH;
  }

  // —— 统一控制显隐：仅在“滚动停止后”触发 —— 
  var scrolling = false, timer;
  function updateAfterStop(){
    scrolling = false;
    btn.classList.remove('is-scrolling');  // 解除“滚动中隐藏”
    placeStatic();                         // 维持静态位置（防止任何抖动）
    btn.classList.toggle('is-visible', beyondThreshold());
  }

  // 滚动时：立刻隐藏（不做计算），停止 STOP_DELAY ms 再判断一次
  window.addEventListener('scroll', function(){
    if(!scrolling){
      scrolling = true;
      btn.classList.add('is-scrolling');   // 立即隐藏
    }
    clearTimeout(timer);
    timer = setTimeout(updateAfterStop, STOP_DELAY);
  }, { passive:true });

  // 视口变化：重新放置并按当前状态判断一次（同样低频）
  window.addEventListener('resize', function(){
    placeStatic();
    clearTimeout(timer);
    timer = setTimeout(updateAfterStop, 120);
  }, { passive:true });

  // 初始：根据阈值决定是否可见
  updateAfterStop();

  // 点击回顶（尊重“减少动画”）
  btn.addEventListener('click', function(){
    var smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top:0, behavior: smooth ? 'smooth' : 'auto' });
  });
})();
